import { z } from 'zod'

export const priceRequestFormSchema = z.object({
  comment: z.string().max(500).optional(),
})
